import { Link } from 'react-router-dom';
import { Button } from '../ui/button';
import { Globe, ArrowRight } from 'lucide-react';

export function WebsitePromo() {
  return (
    <section className="py-16 bg-gradient-to-r from-slate-900 via-slate-800 to-slate-900 relative overflow-hidden" data-testid="website-promo-section">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-1/4 w-64 h-64 bg-cyan-500 rounded-full blur-[120px]" />
        <div className="absolute bottom-0 right-1/4 w-64 h-64 bg-blue-500 rounded-full blur-[120px]" />
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-8">
          <div className="flex items-center gap-6">
            <div className="hidden sm:flex w-20 h-20 bg-gradient-to-br from-cyan-500 to-blue-600 rounded-2xl items-center justify-center flex-shrink-0 shadow-lg shadow-cyan-500/20">
              <Globe className="w-10 h-10 text-white" />
            </div>
            <div>
              <div className="flex items-center gap-3 mb-2">
                <span className="bg-cyan-500/20 text-cyan-400 text-xs font-bold uppercase tracking-wider px-3 py-1 rounded-full border border-cyan-500/30">
                  New Service
                </span>
              </div>
              <h3 className="text-2xl sm:text-3xl font-black text-white" style={{ fontFamily: 'Chivo, sans-serif' }}>
                Professional Website Design — <span className="text-gradient">$550</span>
              </h3>
              <p className="text-slate-400 mt-1">
                Get a professional, mobile-ready business website. Fast turnaround, no hidden costs.
              </p>
            </div>
          </div>
          <Link to="/contact">
            <Button size="lg" className="bg-cyan-500 hover:bg-cyan-600 text-white font-semibold shadow-lg shadow-cyan-500/30 btn-hover-lift whitespace-nowrap" data-testid="website-promo-cta">
              Get Started <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
}
